import React from "react";
import { IcCompartir } from "./player-components/IconosPlayer";

//compartir la experiencia
const MenuRedes = ({ handleLinkButton }) => (
  <div id="menuFlotanteRedes">
    <button
      type="button"
      className="p360-btn p360-vidrio fourth-step"
      title="Compartir"
      aria-label="Compartir la experiencia"
      onClick={() => handleLinkButton()}
    >
      <IcCompartir />
    </button>
  </div>
);
export default MenuRedes;
